import { RootState } from 'PROCUREMENTTypes';
import { SessionReducerState } from '../reducers/session';

export function getSession(state: RootState): SessionReducerState {
    return state.session;
}